<template>
    <div v-if="showRetail">
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom">
                <span id="font_bold">Retail</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom">
                <span id="font_bold" class="italic">Retail - Credit</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="bold-text label-field text-left no-right no-bottom">
                Credit Card Mentioned:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <span v-if="credit_card_mentioned ==1">Yes</span>
                <span v-else>No</span>

            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Retail',
    props : [
        "showRetail"
    ],
    computed: {
        ...mapGetters({
            sector: 'ProductData/getSector',
        }),
        credit_card_mentioned: {
            get: function() {
                return this.$store.getters['ProductData/getRetailCreditCardMentioned']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/setRetailCreditCardMentioned', o)
            }
        }
    }
}
</script>